import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'user-pub-banner-skeleton',
  templateUrl: './banner-skeleton.component.html',
  styleUrls: ['./banner-skeleton.component.scss']
})
export class UserProfileBannerSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
